import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "EazyCarTrack PHV Private Hire Rental";
const BASE = "https://eazycartrack.co.uk";

export default function Seo({ title, description, path = "", noindex = false, jsonLd, ogImage }) {
  const fullTitle = title ? `${title} | ${SITE}` : `Taxi Rental Manchester | ${SITE}`;
  const canonical = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
